import { render, staticRenderFns } from "./IconBetaSettings.vue?vue&type=template&id=4ac1b51c&"
import script from "./IconBetaSettings.vue?vue&type=script&lang=ts&"
export * from "./IconBetaSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports